<div class="loading-container">
  <div class="loading-content">
    <!-- Loading State -->
    @if (isLoading()) {
      <div class="loading-section">
        <div class="spinner-container">
          <mat-spinner diameter="60" strokeWidth="4" color="primary"></mat-spinner>
        </div>
        <div class="content-section">
          <h2 class="loading-title">{{ displayConfig().title }}</h2>
          <p class="loading-message">{{ displayConfig().message }}</p>
          <div class="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    }

    <!-- Error/Not Found/Empty States -->
    @if (!isLoading()) {
      <div class="state-section">
        <div class="state-icon">
          <mat-icon [attr.aria-label]="displayConfig().title">{{ displayConfig().icon }}</mat-icon>
        </div>
        
        <div class="state-content">
          <h2 class="state-title">{{ displayConfig().title }}</h2>
          <p class="state-message">{{ displayConfig().message }}</p>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
          @if (displayConfig().showRetry) {
            <button 
              mat-raised-button 
              color="primary" 
              (click)="onRetry()"
              class="action-button">
              <mat-icon>refresh</mat-icon>
              Try Again
            </button>
          }
          
          <button 
            mat-button 
            (click)="onGoBack()"
            class="action-button secondary">
            <mat-icon>arrow_back</mat-icon>
            Go Back
          </button>
          
          <button 
            mat-button 
            (click)="onGoHome()"
            class="action-button secondary">
            <mat-icon>home</mat-icon>
            Home
          </button>
        </div>
      </div>
    }

    <!-- Custom Content Slot -->
    @if (config.customContent) {
      <div class="custom-content">
        <ng-content></ng-content>
      </div>
    }
  </div>

  <!-- Background Pattern -->
  <div class="background-pattern" aria-hidden="true">
    <div class="pattern-dot"></div>
    <div class="pattern-dot"></div>
    <div class="pattern-dot"></div>
    <div class="pattern-dot"></div>
    <div class="pattern-dot"></div>
  </div>
</div>
